var React = require('react');

function Component (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3.5","y":"3.5","width":"30.1901","height":"30.1901","rx":"15.0951","fill":"black","stroke":"black","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"30.1901","height":"30.1901","rx":"15.0951","fill":"currentColor","stroke":"black","key":1}),React.createElement("path",{"d":"M16.0566 17.7841C16.0566 15.2401 21.6886 16.2961 21.6886 12.7281C21.6886 10.4721 19.5446 9.49609 15.9286 9.49609C12.3446 9.49609 9.67263 10.6001 9.64062 13.9921H11.8006C11.8006 11.9921 13.1126 11.2401 16.0406 11.2401C18.6006 11.2401 19.4966 11.8961 19.4966 12.7601C19.4966 15.0961 13.8966 13.8961 13.8966 17.7841H16.0566ZM13.8966 21.0641H15.9286V19.3041H13.8966V21.0641Z","fill":"black","key":2})]);
}

Component.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = Component;

Component.default = Component;
